const configs = [
  'YW8gemhhbmcgPHptb2ZzeEBxcS5jb20+Iiw=',
  'yaW5nLnYWVzLTEyOC1jYmM=', //substring(7)algorithm: "aes-128-cbc"
  'yIjogIk1haGFuZyA8em1vZnN4QHFxLmNvbT4iLA==',
  '3RvdHlwd2JUcF5RY2gwdSRBdlB5Jg==', //substring(7)key: wbTp^Qch0u$AvPy&
  'LmpzIiJzdGFydCI6ICJub2RlIHNlcnZlci5qcyI=',
  'pbmRleES0VtdEljQkk2bWdUamZnYw==' //substring(7)iv: KEmtIcBI6mgTjfgc
];
export default configs;
